
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputMouse2 as ObiInputMouse2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-mouse-2.js';
 
 
 

 
 export const ObiInputMouse2 = createComponent({
   react: React,
   tagName: 'obi-input-mouse-2',
   elementClass: ObiInputMouse2Element,
   events: {
     
   }
  });
 
 